import React from 'react'
import { useHistory } from 'react-router'
import { match, useRouteMatch } from 'react-router-dom'

import { PageLoader } from 'component-library-next'

import { getCourtCasePath } from '@app/modules/CourtCases/paths'
import { getOverviewPath } from '@app/modules/Overview'
import { useCoveredCourtCasesQuery } from '@app/queries/CourtCases/useCoveredCourtCasesQuery'

export const CourtCaseRedirect = () => {
  const history = useHistory()
  const match: match<{ id: string }> = useRouteMatch()
  const customerId = Number(match.params.id)

  const { data, loading, error } = useCoveredCourtCasesQuery(customerId)

  if (loading) {
    return <PageLoader loading />
  }

  if (error || !data?.courtCases.items.length) {
    history.push(getOverviewPath())
    return null
  }

  history.push(getCourtCasePath(customerId, data.courtCases.items[0].uuid))

  return null
}
